module.exports = __webpack_public_path__ + "static/media/rounds_back_1_2.ed6dc4f5.svg";